import { render, staticRenderFns } from "./deatil.vue?vue&type=template&id=71742948&scoped=true"
import script from "./deatil.vue?vue&type=script&lang=js"
export * from "./deatil.vue?vue&type=script&lang=js"
import style0 from "./deatil.vue?vue&type=style&index=0&id=71742948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71742948",
  null
  
)

export default component.exports